import React, { useEffect, useState } from "react";
import SearchAudioshop from "../SearchAudioshop/SearchAudioshop";
import { fetchData, refreshToken } from "../../helper/fetchData";
import {
  useDataStore,
  useLoginStore,
  usePlayerStore,
} from "../../hooks/useNavStore";
import { useMsal } from "@azure/msal-react";
import RecentList from "../RecentList/RecentList";
import Modal from "../Modal/Modal";
import useScreenWidth from "../../helper/useScreenWidth";

const Welcome = ({ data, loading = false }) => {
  const [backgroundImageUrl, setBackgroundImageUrl] = useState(null);
  const [theStyle, setTheStyle] = useState({
    backgroundImage: backgroundImageUrl || "#d3d3d3",
    backgroundSize: "33.33%",
    backgroundPosition: "left, center, right",
    backgroundRepeat: "no-repeat",
  });
  const screenWidth = useScreenWidth();

  const { tokenZ, setTokenGlobal } = useLoginStore();

  const { textOnly, show25, setShow25, emailAddress, setAct } = useDataStore();

  const hostname = window.location.hostname;

  const isBeta = hostname === "audioshop-beta.blr.de";

  const selectRandomImages = (sw) => {
    const maxImages = sw < 1100 ? 2 : 3; // ← use 2 for small screens
    const uniqueImages = new Set();

    const isMobile = sw < 1100;

    while (uniqueImages.size < maxImages && data.length > uniqueImages.size) {
      const randomIndex = Math.floor(Math.random() * data.length);
      uniqueImages.add(data[randomIndex].image);
    }

    const images = Array.from(uniqueImages);
    const backgroundImages = images.map((img) => `url(${img})`).join(", ");

    setBackgroundImageUrl(backgroundImages); // optional storage

    setTheStyle({
      backgroundImage: backgroundImages || "#d3d3d3",
      backgroundSize: isMobile ? "100% 50%, 100% 50%" : "33.3%", // full width, half height for each
      backgroundPosition: isMobile
        ? "top center, bottom center"
        : "left, center, right", // one at top, one at bottom
      backgroundRepeat: "no-repeat",
    });
  };

  useEffect(() => {
    // Initial image selection
    selectRandomImages(screenWidth);

    // Update images every 5 minutes
    const intervalId = setInterval(selectRandomImages, 300000); // 5 minutes in ms

    // Cleanup on unmount
    return () => clearInterval(intervalId);
  }, [data, screenWidth]);

  const [loading25, setLoading25] = useState(true);

  const { instance } = useMsal();
  const activeAccount = instance.getActiveAccount();

  const [show, setShow] = useState(false);

  const { setCurrentAudio } = usePlayerStore();

  const ridLocal = localStorage.getItem("rid") || null;
  const [RID, setRID] = useState(ridLocal);

  const activityWs = (type) => {
    let action = "activity";
    let data = {
      action: action,
      data: {
        rId: RID,
        newsType: "ASP1",
        email: emailAddress,
        type,
      },
    };
    // sendMessage(JSON.stringify(data));
    setAct(JSON.stringify(data));
  };

  // useEffect(() => {
  //   if (screenWidth < 1100) {
  //     setTheStyle({
  //       backgroundImage: backgroundImageUrl || "#d3d3d3",
  //       backgroundSize: "100%",
  //       backgroundPosition: "center",
  //       backgroundRepeat: "no-repeat",
  //     });
  //   }
  // }, [screenWidth]);

  return (
    <div className={`welcome ${textOnly ? "hidden" : " "} mx-3 md:mx-4`}>
      <div className="background-layer" style={theStyle}></div>

      {/* Main content, unaffected by the gradient overlay */}
      <div className="content ">
        <div className="flex justify-between h-full relative">
          <div
            className="jigo_container flex items-center self-end cursor-pointer ml-2 mb-2"
            onClick={() => {
              setShow25(true);
              activityWs(`More: Die neuesten 25 Meldungen`);
            }}
          >
            <p className="jigo p-2 forgotten">25</p>

            <p
              tabIndex={0}
              className="text"
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  setShow25(true);
                  activityWs(`More: Die neuesten 25 Meldungen`);
                }
              }}
            >
              Die neuesten 25 Meldungen
            </p>
          </div>

          <div className="w-full flex items-center flex-col mt-[26px]  md:mt-[32px]">
            <div className="announcement">
              <p className="as_log">AudioShop</p>
            </div>

            <div className="w-[75%] md:w-[50%]">
              <SearchAudioshop loading={loading} />
            </div>
          </div>
          <div className="w-[348px] hidden md:block"></div>
        </div>
      </div>
    </div>
  );
};

export default Welcome;
